export enum SavingStates {
  Saving = 'SAVING',
  Saved = 'SAVED',
}
